import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/FetchUsersOfOrganization";

export function* fetchUsersOfOrganization(action: Actions.FetchUsersOfOrganizationAction) {
    const { payload } = action;
    const { credentials, organizationId } = payload;

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.getUsersOfOrganization(organizationId, { includeRoles: true });
        yield put(Actions.fetchUsersOfOrganizationEnd(undefined, organizationId, result));
    } catch (e) {
        yield put(Actions.fetchUsersOfOrganizationEnd(e, organizationId));
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchFetchUsersOfOrganization() {
    yield takeEvery(Actions.FETCH_USERS_OF_ORGANIZATION, fetchUsersOfOrganization);
}
